/**
 * Header.tsx
 * ----------
 * Application header with navigation and language switcher.
 * - Responsive and multilingual.
 */


import React from 'react';
import FinnishFlag from './FinnishFlag';
import { useProgress } from '../../context/ProgressContext';
import Button from './Button';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const { language, setLanguage } = useProgress();
  const lang = (['en', 'fi', 'sv'].includes(language) ? language : 'fi') as 'en' | 'fi' | 'sv';

  const t = {
    home: {
      en: 'Home',
      fi: 'Etusivu',
      sv: 'Hem',
    },
    about: {
      en: 'About',
      fi: 'Tietoa',
      sv: 'Om',
    },
    services: {
      en: 'Services',
      fi: 'Palvelut',
      sv: 'Tjänster',
    },
    contact: {
      en: 'Contact',
      fi: 'Yhteystiedot',
      sv: 'Kontakt',
    },
    company: {
      en: 'Redinor Oy',
      fi: 'Redinor Oy',
      sv: 'Redinor Oy',
    },
  };

  return (
    <header
      className="flex items-center justify-between gap-4 w-full p-4
  bg-gradient-to-r from-blue-100 to-blue-300 shadow-inner"
    >
      <div>
        <Link
          to={'/'}
          className="flex gap-2 transform hover:scale-110 duration-200 
        font-bold text-xl text-blue-900"
        >
          <FinnishFlag className="w-7 h-7" />
          {t.company[lang]}
        </Link>
      </div>
      <div
        className="hidden sm:flex"
        style={{ display: window.innerWidth < 681 ? 'none' : undefined }}
      >
        <nav
          className="flex gap-8 text-base 
        font-medium items-center justify-center"
        >
          <Link className="transform hover:text-gray-700 hover:scale-110 duration-200" to={'/'}>
            {t.home[lang]}
          </Link>
          <Link
            className="transform hover:text-gray-700 hover:scale-110 duration-200"
            to={'/about'}
          >
            {t.about[lang]}
          </Link>
          <Link
            className="transform hover:text-gray-700 hover:scale-110 duration-200"
            to={'/services'}
          >
            {t.services[lang]}
          </Link>
          <Link
            className="transform hover:text-gray-700 hover:scale-110 duration-200"
            to={'/contact'}
          >
            {t.contact[lang]}
          </Link>
        </nav>
      </div>
      <div className="flex gap-2">
        <Button
          gradient
          onClick={() => setLanguage('en')}
          className={
            'transform hover:scale-105 bg-blue-500 hover:bg-blue-700 duration-20 text-white hover:text-gray-100'
          }
        >
          EN
        </Button>
        <Button
          gradient
          onClick={() => setLanguage('fi')}
          className={
            'transform hover:scale-105 bg-blue-500 hover:bg-blue-700 duration-20 text-white hover:text-gray-100'
          }
        >
          FI
        </Button>
        <Button
          gradient
          onClick={() => setLanguage('sv')}
          className={
            (language === 'sv'
              ? 'transform hover:scale-105 bg-red-700 text-white'
              : 'bg-white hover:text-gray-100') + ' duration-200'
          }
        >
          SV
        </Button>
      </div>
    </header>
  );
};

export default Header;
